import React, { ReactNode } from 'react';
import { Square, ISquareProps } from '@grubhubprod/gh-cookbook-react/dist';

export interface PageSectionProps {
  bg?: ISquareProps['bg'];
  borderRadius?: ISquareProps['borderRadius'];
  dataTestId?: string;
  fullHeight?: boolean;
  children: ReactNode;
}

export const PageSection: React.FC<PageSectionProps> = ({
  children,
  bg = 'untintedBackground',
  borderRadius = '8px',
  dataTestId,
  fullHeight = false,
}) => {
  const appliedHeight = fullHeight ? '100%' : undefined;

  return (
    <Square
      bg={bg}
      borderRadius={borderRadius}
      data-testid={dataTestId}
      height={appliedHeight}
      inset="lg"
    >
      {children}
    </Square>
  );
};
